import { Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
  selector: 'app-spinner',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  // eslint-disable-next-line @typescript-eslint/quotes
  template: `<aui-spinner size="{{ size }}"></aui-spinner>`,
})
export class SpinnerComponent {
  // TODO: Looks like input "size" does not work
  @Input() size = 'small';
}
